// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-component-container {
  background-color: #40A0C1;
  border-radius: 45px;
  color: white;
  font-size: 14px;
  font-weight: 700;
  min-width: 70px;
  box-sizing: border-box;
  height: 35px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AACD","sourcesContent":[".button-component-container {\n\tbackground-color: #40A0C1;\n\tborder-radius: 45px;\n\tcolor: white;\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tmin-width: 70px;\n\tbox-sizing: border-box;\n\theight: 35px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px;\n\tuser-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
